import { render } from "./Faq1.vue?vue&type=template&id=02c0b781"
import script from "./Faq1.vue?vue&type=script&lang=js"
export * from "./Faq1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__